<template>
  <div class="dashboard-components">
    <div class="dashboard-p5-content">
      <div class="dashboard-p5-treemap-main">
        <el-row :gutter="30">
          <el-col :span="20">
            <div id="treemapid" class="dashboard-p5-treemap-item"></div>
          </el-col>
          <el-col :span="4">
            <div class="treemapselector">
              <el-select v-model="type" placeholder="请选择" size="mini" @change="initData()" popper-class="singlecodetopselect">
                <el-option
                  class="barchart-miniselector"
                  v-for="item in typeoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="dashboard-p5-treemap-footer">
        <ul class="chartcolortxt">
          <li><span class="color1"></span>{{ $t('charttxt.z1') }}</li>
          <li><span class="color2"></span>{{ $t('charttxt.z2') }}</li>
          <li><span class="color3"></span>{{ $t('charttxt.z3') }}</li>
          <li><span class="color4"></span>{{ $t('charttxt.z4') }}</li>
          <li><span class="color5"></span>{{ $t('charttxt.z5') }}</li>
          <li><span class="color7"></span>{{ $t('charttxt.z7') }}</li>
          <li><span class="color6"></span>{{ $t('charttxt.z6') }}</li>
        </ul>
      </div>      
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      type: 0,
			typeoptions: [{
				label: this.$t('SingleCodeAnalysis.t08'),
				value: 0
			},{
				label: this.$t('SingleCodeAnalysis.t07'),
				value: 1
			},{
				label: this.$t('SingleCodeAnalysis.t06'),
				value: 2
			},{
				label: '当月',
				value: 3
			}],
    }
  },

  mounted(){
    this.initTreemap()
  },

  methods: {
    /**
     * 初始化页面
     */
    initData: function(){

    },

    /**
     * treemap 图表
     */
    initTreemap: function(chartdata){
      let that = this
      let myBarChart = that.echarts.init(document.getElementById('treemapid'))
      myBarChart.clear()
      myBarChart.setOption({
        tooltip: {
          padding: 0,
          backgroundColor: 'rgba(50,50,50,0)',
          borderColor: 'rgba(50,50,50,0)',
          borderWidth: 0,
          formatter: function (obj) {
            return '<div style="padding:10px; min-width:200px; border-radius: 20px; background-color: rgba(50,50,50,0.8);">'
              + '<h2 style="font-size:16px; font-weight:normal; padding-bottom:10px; text-align: left;">' + obj.data.item + '</h2>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip2 + '<span style="float:right;">'+ that.millonFormat(obj.data.value) + ' ' + obj.data.newunit + '</span></h3>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip1 + '<span style="float:right;">'+ that.millonFormat(obj.data.proportion) +'%</span></h3>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip3 + '<span style="float:right;">'+ that.millonFormat(obj.data.growth) + ' ' + obj.data.newunit + '</span></h3>'
              + '</div>'
              + '<div style="margin:auto; width: 0; height: 0; border-left: 20px solid transparent; border-right: 20px solid transparent; border-top: 20px solid rgba(50,50,50,0.8);"></div>'
          },
          position: function (point) {
            return [point[0] - 100, point[1] - 190]
          }
        },
        series: [{
          left: 10,
          right: 10,
          top: 10,
          bottom: 10,
          type: 'treemap',
          roam: false,
          nodeClick: false,
          breadcrumb: {
            show: false
          },
          label: {
            normal: {
              position: 'insideBottomLeft',
              formatter: function (params) {
                let arr = ['{name|' + params.data.item + '}', '{percent|' + params.data.proportion + '%}']
                return arr.join('\n')
              },
              rich: {
                name: {
                  fontSize: 14,
                  lineHeight: 20,
                  color: '#FFFFFF'
                },
                percent: {
                  fontSize: 12,
                  lineHeight: 18,
                  color: '#FFFFFF'
                },
              }
            }
          },
          data: chartdata,
          itemStyle: {
            gapWidth: 1,
            borderColor: 'rgb(51,63,80)'
          }
        }],
        color: ['rgb(0,148,115)', 'rgb(51,102,153)', 'rgb(240,192,90)', 'rgb(190,69,116)', 'rgb(112,48,160)', 'rgb(150,79,76)']
      })

      $(window).resize(function () {
        myBarChart.resize();
      }) 
    },
  }
}
</script>